/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { BreadCrumbsContext } from "../../Context/breadCrumbsContext";
import { breadCrumbsEnum } from "../../Utils/Constants";
import { getData } from "../../Services/getData";
import { StatusEnum, UrlEnum, europeanDate, paymentTypeEnum } from "../../Utils/Utils";
import ReportsStatistically from "../Reports/ReportsStatistically";
import { Vocabulary } from "../../Utils/Vocabulary";

export default function HomePage() {
  const breadCrumbsContext = useContext(BreadCrumbsContext);
  const [startDate, setStartDate] = useState(moment().subtract(30, "d").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [totalOrders, setTotalOrders] = useState(0);
  const [ordersNumberForStatusAndPaymentType, setOrdersNumberForStatusAndPaymentType] = useState<any>({
    ordersNumberForEachStatus: [],
    ordersNumberForEachPaymentType: [],
  });

  useEffect(() => {
    breadCrumbsContext.setBreadCrumbs([`${breadCrumbsEnum.dashboard}`]);
  }, []);

  useEffect(() => {
    fetchStats();
  }, [startDate, endDate]);

  async function fetchStats() {
    const url = `${UrlEnum.reports}/${startDate}/${endDate}/null/null`;
    const response = await getData(url);
    if (response && response.data) {
      processStats(response.data);
    }
  }

  function processStats(data: any) {
    let ordersNumberForEachStatus = data.ordersNumberForEachStatus.filter(
      (s: any) => s.status !== StatusEnum.estimated
    );
    if (ordersNumberForEachStatus.length === 0)
      ordersNumberForEachStatus = [...data.ordersNumberForEachStatus];

    const estimated = data.ordersNumberForEachStatus.filter(
      (s: any) => s.status === StatusEnum.estimated
    );
    let ordersNumberForEachPaymentType = [...data.ordersNumberForEachPaymentType];
    if (estimated.length !== 0) {
      ordersNumberForEachPaymentType = [
        ...data.ordersNumberForEachPaymentType.map((item: any) => {
          if (item.paymentType === paymentTypeEnum.normal)
            return { ...item, count: item.count - estimated[0].count };
          return item;
        }),
        { paymentType: estimated[0].status, count: estimated[0].count },
      ];
    }

    const total = ordersNumberForEachStatus.reduce(
      (sum: number, s: any) => sum + (s.count || 0),
      0
    );
    setTotalOrders(total);
    setOrdersNumberForStatusAndPaymentType({
      ordersNumberForEachStatus,
      ordersNumberForEachPaymentType,
    });
  }

  return (
    <Grid container spacing={2} style={{ padding: "16px 0" }}>
      <Grid item xs={12}>
        <h2 style={{ margin: "0 0 16px 0", fontSize: 22 }}>{Vocabulary.dashboard}</h2>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CalendarMonthIcon sx={{ color: "#4d5e80" }} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label={Vocabulary.startDate}
                value={moment(startDate)}
                maxDate={moment(endDate)}
                onChange={(val: any) => {
                  if (val && val.isValid())
                    setStartDate(val.format("YYYY-MM-DD"));
                }}
                inputFormat={europeanDate}
                renderInput={(params) => (
                  <TextField {...params} size="small" style={{ width: 180 }} />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CalendarMonthIcon sx={{ color: "#4d5e80" }} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label={Vocabulary.endDate}
                value={moment(endDate)}
                minDate={moment(startDate)}
                onChange={(val: any) => {
                  if (val && val.isValid())
                    setEndDate(val.format("YYYY-MM-DD"));
                }}
                inputFormat={europeanDate}
                renderInput={(params) => (
                  <TextField {...params} size="small" style={{ width: 180 }} />
                )}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <ReportsStatistically
          ordersNumberForStatusAndPaymentType={ordersNumberForStatusAndPaymentType}
          totalOrders={totalOrders}
        />
      </Grid>
    </Grid>
  );
}
